<template>
  <div>
    <section
      id="intro"
      class="main-row"
    >
      <b-container class="px-md-0">
        <b-row>
          <b-col
            md="7"
            lg="6"
          >
            <h1 v-html="$t('hos.intro.title')"></h1>
            <h2 v-html="$t('hos.intro.subtitle')"></h2>
            <!-- Mobile -->
            <ul class="buttons d-sm-none">
              <li>
                <a
                  class="btn btn-primary"
                  href="https://authent.framatalk.org/"
                  v-html="$t('hos.intro.btn-create-a-talk')"
                ></a>
              </li>
              <li>
                <a
                  class="btn btn-outline-warning"
                  :href="$t('hos.data.docs')"
                  onclick="return false;"
                  @click="docs = true"
                >
                  <i class="fas fc-g6 fa-circle-play"></i>
                  <span v-html="$t('hos.intro.btn-tour')"></span>
                </a>
              </li>
            </ul>
            <!-- Tablet/Desktop -->
            <ul class="buttons d-none d-sm-flex">
              <li>
                <a
                  class="btn btn-primary btn-lg"
                  href="https://authent.framatalk.org/"
                  v-html="$t('hos.intro.btn-create-a-talk')"
                ></a>
              </li>
              <li>
                <a
                  class="btn btn-lg btn-outline-warning"
                  :href="$t('hos.data.docs')"
                  onclick="return false;"
                  @click="docs = true"
                >
                  <i class="fas fa-circle-play"></i>
                  <span v-html="$t('hos.intro.btn-tour')"></span>
                </a>
              </li>
            </ul>
          </b-col>
        </b-row>
        <b-row
          id="learn-more"
          aria-hidden="true"
          align-h="center"
          class="d-none d-sm-flex"
        >
          <input
            id="btn-learn-more"
            type="checkbox"
            class="sr-only"
            @change="$parent.$children[1].$refs['what']
              .scrollIntoView({ behavior: 'smooth' })"
          />
          <label
            for="btn-learn-more"
            class="btn btn-sm btn-link p-0"
          >
            <span v-html="$t('hos.intro.more', $t('hos.data'))"></span>
            <i class="fas fa-lg fa-chevron-down d-block fc-g8"></i>
          </label>
        </b-row>
      </b-container>
    </section>

    <modal-docs
      :link="$t('hos.data.docs')"
      :open="docs"
    />
  </div>
</template>

<script>
import ModalDocs from '../../../commons/components/ModalDocs.vue';

export default {
  components: {
    ModalDocs,
  },

  data() {
    return {
      docs: false,
    };
  },
};
</script>

<style lang="scss">
#intro {
  filter: drop-shadow(2px 5px 4px rgba(0, 0, 0, 0.2));
  padding: 1rem 0 3rem;
  position: relative;
  z-index: 1;

  @media (max-width: 480px) {
    max-height: 600px;
  }

  &::before,
  &::after {
    display: block;
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  &::before {
    background: var(--f-f7);
    -webkit-clip-path: polygon(0 0, 0 100%, 100% 83%, 100% 0);
    clip-path: polygon(0 0, 0 100%, 100% 83%, 100% 0);

    @media (max-width: 768px) {
      -webkit-clip-path: polygon(0 0, 0 100%, 100% 93%, 100% 0);
      clip-path: polygon(0 0, 0 100%, 100% 93%, 100% 0);
    }
  }

  &::after {
    background: var(--f-g5);
    background-image: url('../../../public/img/intro.jpg');
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    -webkit-clip-path: polygon(0 0, 100% 0, 100% 100%, 0 88%);
    clip-path: polygon(0 0, 100% 0, 100% 100%, 0 88%);

    @media (max-width: 768px) {
      -webkit-clip-path: polygon(0 0, 100% 0, 100% 98%, 0 95%);
      clip-path: polygon(0 0, 100% 0, 100% 98%, 0 95%);
    }
  }

  .container {
    position: relative;
    z-index: 1;
  }

  h1 {
    color: var(--f-g8);
    font-size: 5rem;
    font-weight: 300;
    margin: 4rem 0 3rem;

    @media (max-width: 992px) {
      font-size: 4rem;
      margin: 3rem 0 2rem;
    }

    @media (max-width: 768px) {
      font-size: 3rem;
      margin: 2rem 0 1.5rem;
    }
  }

  h2 {
    color: var(--f-g8);
    font-size: 2rem;
    font-weight: 300;
    line-height: 1.25;
    margin: 0;

    @media (max-width: 992px) {
      max-width: 75%;
      font-size: 1.75rem;
    }

    @media (max-width: 768px) {
      font-size: 1.5rem;
    }
  }

  #learn-more {
    label {
      color: var(--f-g8);
      background: none;
      text-decoration: none;
    }

    span {
      background: linear-gradient(180deg,#0000,#fff4,#0000);
      border-radius: 1rem;
      padding: .25rem ;
      font-size: .875rem;
    }

    input:checked ~ label {
      visibility: hidden;
    }
  }

  .buttons {
    display: flex;
    flex-direction: row;
    margin: 3rem 0 3.5rem;
    padding: 0;
    list-style: none;
    max-width: 90%;

    @media (max-width: 1200px) {
      flex-direction: column;
      max-width: 66%;
    }

    @media (max-width: 768px) {
      flex-direction: column;
      max-width: 50%;
    }

    > li {
      flex-direction: column;
      flex-grow: 1;
      flex-shrink: 0;
      text-align: left;
      justify-content: center;
      align-items: center;
      margin: .25rem .75rem;

      @media (max-width: 1200px) {
        margin: .5rem 0 0;
      }

      &:first-of-type {
        margin-left: 0;
      }

      &:last-of-type {
        margin-right: 0;
      }

      > * {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
      }
    }

    .btn {
      font-weight: bold;

      i.fas {
        margin-right: .25rem;
      }

      &.dropdown-toggle {
        max-width: 2.5rem;
      }
    }

    .btn-outline-warning {
      background: #fff;
      border-color: #fff;
      font-weight: bold;

      &:hover, &:focus, &:active {
        background: var(--f-o7);
        border-color: var(--f-o7);
        color: #fff;
      }
    }

    .dropdown-menu {
      background-color: var(--f-g1);
    }

    .btn-primary.dropdown-toggle-split {
      filter: brightness(.9)
    }
  }

  .alert-outline {
    background: #fbfcfddd;
    margin-bottom: 2.5rem;
    max-width: 90%;

    @media (max-width: 768px) {
      max-width: 50%;
    }

    @media (max-width: 576px) {
      font-size: .875rem;
      margin-top: 2.5rem;
      margin-bottom: 0;
      max-width: 100%;
    }
  }
}
</style>
